/* @flow */

import inputmask from 'inputmask';
import formatarReal from './formatar-real';
import isAndroid from './is-android';

const digitacaoDinheiro = (e: Event) => {
    const input = e.srcElement;
    if (!(input instanceof HTMLInputElement)) {
        return;
    }

    const resultado = /\d*[.|,]?\d{0,2}/g.exec(input.value);
    if (resultado) {
        const [valor] = resultado;
        input.value = valor;
    }
};

const tirandoFocoInputDinheiro = (e: Event) => {
    const input = e.srcElement;
    if (input instanceof HTMLInputElement && input.value !== '') {
        input.value = formatarReal(input.value);
    }
};

export const mascaraDinheiro = (input: HTMLInputElement) => {
    input.addEventListener('input', digitacaoDinheiro);
    input.addEventListener('change', tirandoFocoInputDinheiro);
};

export const removerDinheiro = (input: HTMLInputElement) => {
    input.removeEventListener('input', digitacaoDinheiro);
    input.removeEventListener('change', tirandoFocoInputDinheiro);
};

const criarMascara = (mascara: string | string[]) => (input: any) => {
    if (input && !isAndroid()) {
        inputmask(mascara).mask(input);
    }
};

export const mascaraCpf = criarMascara('999.999.999-99');
export const mascaraCpfCnpj = criarMascara(['999.999.999-99', '99.999.999/9999-99']);
export const mascaraCnpj = criarMascara('99.999.999/9999-99');
export const mascaraDdmmyyyy = criarMascara('99/99/9999');
export const mascaraTelefone = criarMascara(['(99) 9999-9999', '(99) 99999-9999']);
export const mascaraTelefoneFixo = criarMascara('(99) 9999-9999');
export const mascaraTelefoneCelular = criarMascara('(99) 99999-9999');
export const mascaraCep = criarMascara('99999-999');
export const mascaraCartaoCredito = criarMascara('9999 9999 9999 9999');
